import React, { useEffect, useCallback } from "react";
import "../../../../css/Settings/DeviceSetttings/deviceSettings.css";
import { useState, useReducer } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Autocomplete, MenuItem, Select, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setSnackMsg, setSuccessSnack, setErrorSnack } from "../../Sales/Billing/Slice/billingScreenSlice";
import { getAllPrinterDevicesAPICall } from "./deviceSettingsAPI";
import DownloadButton from "./DownloadButton";
import QzTrayInstallDialog from "./QzTrayInstallDialog";
import SocketPrintInstallDialog from "./SocketPrintInstallDialog";
import QzTrayCredentialsDialog from "./QzTrayCredentialsDialog";
import { isQzTrayAvailable, getQzPrinters, hasQzCredentials } from "./qzTrayService";
import { isSocketPrintAvailable, getSocketPrinters, disconnectSocket } from "./socketPrintService";
import { store_printers_list } from "./deviceSettingsSlice";
import { getTemplateInfoAPI } from "../posReceipt/posReceiptApi";
import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton, Tooltip, CircularProgress, Dialog, DialogTitle, DialogContent } from '@mui/material';
import CancelIcon from "@mui/icons-material/Cancel";
import ReceiptTemplatePreview from "./ReceiptTemplatePreview";
import axios from "axios";
import { HEADERS } from "../../../../API/UrlAndPaths";
import { update_all_products_list } from "../../../../Redux/Product List/allProductsListSlice";
import { get_all_posCategory } from "../../Inventory/Configuration/POSCategory/posCategorySlice";
import Chip from '@mui/material/Chip';

export const DeviceSettings = () => {
  
  const dispatch=useDispatch()

  const {printersList}=useSelector((state)=>state.deviceSettingsSlice)
  const allProductsList = useSelector((state) => state.allProductsListSlice.value);
  const posCategoryList = useSelector((state) => state.posCategorySlice?.value);
  const companyProfileData = useSelector((state) => state?.companyProfileSlice?.userValue);
  const companyLogo = companyProfileData?.logo || companyProfileData?.profile?.logo || "";
  const devices=["Printer","Attendance Device","Payment Device","Scanning Device"]
  const printersSize=["58","80"]
  const kotFilterTypes = ['none', 'product', 'category'];
  const imgModes=[1,2]
  const deviceFormsInitialState={
    receipt:null,
    receiptSize:null,
    receiptAuto:false,
    enableBarcode:false,
    enableQrCode:false,
    enableNativeName:false,
    enableKotNativeName:false,
    enableKotPrint: false,
    enableKotPrintAfterPayment:false,
    kot:null,
    kotAuto:false,
    kotSize:null,
    barCode:null,
    receiptImgMode:null,
    logoHeight:"",
    // New option: Use browser's default printer (no print utility needed)
    useBrowserPrint:false,
    // Socket.IO print mode (Node/Socket.IO silent print)
    useSocketPrint:false,
    // KOT filter options for main KOT printer
    kotFilterType: 'none',
    kotFilterProducts: [],
    kotFilterCategories: [],
    kotRawMaterial: false,
    kotPrintNotes: false,
  }

  const [deviceForms, setDeviceForms] = useState(deviceFormsInitialState);

  // Additional printers state - arrays for multiple printers
  const [additionalReceiptPrinters, setAdditionalReceiptPrinters] = useState([]);
  const [additionalKotPrinters, setAdditionalKotPrinters] = useState([]);

  // Template for new additional printer
  const newReceiptPrinterTemplate = {
    areaName: '',
    printer: null,
    size: null,
    imgMode: null,
    logoHeight: '',
    enableBarcode: false,
    enableQrCode: false,
    enableNativeName: false,
    enableKotPrint: false,
    auto: true,
  };

  const newKotPrinterTemplate = {
    areaName: '',
    printer: null,
    size: null,
    enableNativeName: false,
    enableKotPrintAfterPayment: false,
    auto: true,
    kotFilterType: 'none',
    kotFilterProducts: [],
    kotFilterCategories: [],
    kotRawMaterial: false,
    kotPrintNotes: false,
  };

  // Add new additional receipt printer
  const addReceiptPrinter = () => {
    setAdditionalReceiptPrinters([...additionalReceiptPrinters, { ...newReceiptPrinterTemplate }]);
  };

  // Remove additional receipt printer
  const removeReceiptPrinter = (index) => {
    setAdditionalReceiptPrinters(additionalReceiptPrinters.filter((_, i) => i !== index));
  };

  // Update additional receipt printer field
  const updateReceiptPrinter = (index, field, value) => {
    const updated = [...additionalReceiptPrinters];
    updated[index] = { ...updated[index], [field]: value };
    setAdditionalReceiptPrinters(updated);
  };

  // Add new additional KOT printer
  const addKotPrinter = () => {
    setAdditionalKotPrinters([...additionalKotPrinters, { ...newKotPrinterTemplate }]);
  };

  // Remove additional KOT printer
  const removeKotPrinter = (index) => {
    setAdditionalKotPrinters(additionalKotPrinters.filter((_, i) => i !== index));
  };

  // Update additional KOT printer field
  const updateKotPrinter = (index, field, value) => {
    const updated = [...additionalKotPrinters];
    updated[index] = { ...updated[index], [field]: value };
    setAdditionalKotPrinters(updated);
  };

  const [activeBtn, setActiveBtn] = useState("Printer");
  
  // QZ Tray installation dialog state
  const [showQzInstallDialog, setShowQzInstallDialog] = useState(false);
  const [showSocketInstallDialog, setShowSocketInstallDialog] = useState(false);
  const [showQzCredentialsDialog, setShowQzCredentialsDialog] = useState(false);
  const [qzTrayConnected, setQzTrayConnected] = useState(false);
  const [qzCredentialsConfigured, setQzCredentialsConfigured] = useState(false);
  const [socketConnected, setSocketConnected] = useState(false);
  const [templateRefreshing, setTemplateRefreshing] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState(localStorage.getItem('posReceiptTemplate') || 'Not set');
  const [currentFont, setCurrentFont] = useState(localStorage.getItem('posReceiptFont') || 'Arial');
  
  // Font options suitable for thermal printers
  const fontOptions = [
    { value: "Arial", label: "Arial" },
    { value: "Times New Roman", label: "Times New Roman" },
    { value: "Courier New", label: "Courier New" },
    { value: "Roboto Mono", label: "Roboto Mono" },
    { value: "Consolas", label: "Consolas" },
    { value: "Montserrat", label: "Montserrat" },
    { value: "Open Sans", label: "Open Sans" },
    { value: "OCR-B", label: "OCR-B" },
    { value: "DIN 1451", label: "DIN 1451" },
    { value: "Tahoma", label: "Tahoma" },
    { value: "Verdana", label: "Verdana" },
    { value: "Helvetica", label: "Helvetica" },
  ];
  const [templatePreviewOpen, setTemplatePreviewOpen] = useState(false);
  const [previewTemplateId, setPreviewTemplateId] = useState(null);
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  
  // Handler for template selection
  const handleTemplateSelect = (templateId, templateLabel) => {
    const newTemplate = templateId.toString();
    console.log('🧾 BEFORE - currentTemplate:', currentTemplate, 'localStorage:', localStorage.getItem('posReceiptTemplate'));
    console.log('🧾 Setting to:', newTemplate);
    
    localStorage.setItem('posReceiptTemplate', newTemplate);
    
    console.log('🧾 AFTER localStorage:', localStorage.getItem('posReceiptTemplate'));
    
    setCurrentTemplate(newTemplate);
    
    dispatch(setSnackMsg(`${templateLabel} set for offline use`));
    dispatch(setSuccessSnack(true));
    
    // Verify after a short delay
    setTimeout(() => {
      console.log('🧾 VERIFY - currentTemplate state:', currentTemplate, 'localStorage:', localStorage.getItem('posReceiptTemplate'));
    }, 100);
  };
  
  // Template data
  const templateOptions = [
    { id: 1, label: "Template 1", desc: "Standard" },
    { id: 2, label: "Template 2", desc: "With Token" },
    { id: 3, label: "Template 3", desc: "Arabic/English" },
    { id: 4, label: "Template 4", desc: "Compact Token" },
    { id: 5, label: "Template 5", desc: "Compact (Small)" },
    { id: 6, label: "Template 6", desc: "Premium" },
    { id: 7, label: "Template 7", desc: "Arabic Premium" },
    { id: 8, label: "Template 8", desc: "Space Saver" },
    { id: 9, label: "Template 9", desc: "Format 4" },
    { id: 10, label: "Template 10", desc: "Items Image" },
    { id: 11, label: "Template 11", desc: "Token Style" },
  ];

  
  const clickDeviceSettingsPrinter = (key) => {
    setActiveBtn(key);
  };

  const devicesOnChange=(key)=>(e,newValue)=>{
    const {value}=e.target;
    setDeviceForms({...deviceForms,[key]:newValue!==undefined ? newValue:value});
   
  }

  // Helper: build a flat array of product _id strings for a given filter config
  const buildFilterProductIds = (filterType, filterProducts, filterCategories) => {
    if (filterType === 'product' && filterProducts?.length > 0) {
      return filterProducts.map(p => p._id);
    }
    if (filterType === 'category' && filterCategories?.length > 0) {
      const catIds = new Set(filterCategories.map(c => c._id));
      return (allProductsList || [])
        .filter(p => catIds.has(p.poscat))
        .map(p => p._id);
    }
    return [];
  };

  const deviceSubmitClick=()=>{

    // Pre-compute product IDs for main KOT filter
    const mainKotFilterProductIds = buildFilterProductIds(
      deviceForms?.kotFilterType,
      deviceForms?.kotFilterProducts,
      deviceForms?.kotFilterCategories
    );

    // Pre-compute product IDs for each additional KOT printer
    const processedAdditionalKotPrinters = additionalKotPrinters.map(printer => ({
      ...printer,
      kotFilterProductIds: buildFilterProductIds(
        printer.kotFilterType,
        printer.kotFilterProducts,
        printer.kotFilterCategories
      ),
    }));

    let printSettings={
      receiptPrinter:deviceForms?.receipt,
      kotPrinter:deviceForms?.kot,
      receiptAuto:deviceForms?.receiptAuto,
      enableQrCode:deviceForms?.enableQrCode,
      enableKotNativeName:deviceForms?.enableKotNativeName,
      enableNativeName:deviceForms?.enableNativeName,
      enableKotPrint:deviceForms?.enableKotPrint,
      enableKotPrintAfterPayment:deviceForms?.enableKotPrintAfterPayment,
      enableBarcode:deviceForms?.enableBarcode,
      kotAuto:deviceForms?.kotAuto,
      receiptSize:deviceForms?.receiptSize,
      kotSize:deviceForms?.kotSize,
      receiptImgMode:deviceForms?.receiptImgMode,
      logoHeight:Number(deviceForms?.logoHeight)>20?Number(deviceForms?.logoHeight):20,
      // New option: Use browser's default printer (no print utility needed)
      useBrowserPrint:deviceForms?.useBrowserPrint,
      // Socket.IO print mode
      useSocketPrint:deviceForms?.useSocketPrint || false,
      // KOT filter options for main KOT printer
      kotFilterType: deviceForms?.kotFilterType || 'none',
      kotFilterProducts: deviceForms?.kotFilterProducts || [],
      kotFilterCategories: deviceForms?.kotFilterCategories || [],
      kotFilterProductIds: mainKotFilterProductIds,
      kotRawMaterial: deviceForms?.kotRawMaterial || false,
      kotPrintNotes: deviceForms?.kotPrintNotes || false,
      // Additional printers arrays
      additionalReceiptPrinters: additionalReceiptPrinters,
      additionalKotPrinters: processedAdditionalKotPrinters,
    }
    localStorage.setItem("PrinterSettings",JSON.stringify(printSettings))
    dispatch(setSnackMsg("Device Settings updated"))
    dispatch(setSuccessSnack(true))
  }

  // Handle enabling QZ Tray mode - show install dialog if not connected
  const handleQzTrayToggle = async (checked) => {
    if (checked) {
      try {
        // Check if QZ Tray is already available
        const available = await isQzTrayAvailable();
        if (available) {
          // Already connected, try to fetch printers
          try {
            const printers = await getQzPrinters();
            if (printers && printers.length > 0) {
              setQzTrayConnected(true);
              setDeviceForms({ ...deviceForms, useBrowserPrint: true });
              dispatch(store_printers_list(printers));
              dispatch(setSnackMsg("QZ Tray connected! Printers loaded."));
              dispatch(setSuccessSnack(true));
            } else {
              // Connected but no printers found
              setQzTrayConnected(true);
              setDeviceForms({ ...deviceForms, useBrowserPrint: true });
              dispatch(setSnackMsg("QZ Tray connected! No printers found."));
              dispatch(setSuccessSnack(true));
            }
          } catch (printerError) {
            console.error('Error fetching printers:', printerError);
            // Connection might have failed, show install dialog
            setShowQzInstallDialog(true);
          }
        } else {
          // Not connected, show installation dialog
          setShowQzInstallDialog(true);
        }
      } catch (error) {
        console.error('QZ Tray check failed:', error);
        // Show installation dialog on any error
        setShowQzInstallDialog(true);
      }
    } else {
      // Disable QZ Tray mode, switch back to thermal utility
      setDeviceForms({ ...deviceForms, useBrowserPrint: false });
      setQzTrayConnected(false);
      getAllPrinterDevicesAPICall(); // Reload printers from thermal utility
    }
  };

  // Handle successful QZ Tray installation
  const handleQzInstallSuccess = (printers) => {
    setQzTrayConnected(true);
    setDeviceForms({ ...deviceForms, useBrowserPrint: true });
    dispatch(store_printers_list(printers));
    dispatch(setSnackMsg("QZ Tray setup complete! Printers loaded."));
    dispatch(setSuccessSnack(true));
  };

  // Handle QZ Tray install dialog close (cancelled)
  const handleQzInstallClose = () => {
    setShowQzInstallDialog(false);
    // Don't enable the option if cancelled
  };

  // Handle credentials dialog
  const handleCredentialsSuccess = () => {
    setQzCredentialsConfigured(true);
    dispatch(setSnackMsg("QZ Tray credentials configured! Silent printing enabled."));
    dispatch(setSuccessSnack(true));
  };

  // Handle enabling Socket Print mode
  const handleSocketPrintToggle = async (checked) => {
    if (checked) {
      try {
        const available = await isSocketPrintAvailable();
        if (available) {
          const printers = await getSocketPrinters();
          setSocketConnected(true);
          setDeviceForms({ ...deviceForms, useSocketPrint: true, useBrowserPrint: false });
          setQzTrayConnected(false);
          dispatch(store_printers_list(printers || []));
          dispatch(setSnackMsg(`Socket Print connected! ${(printers || []).length} printer(s) found.`));
          dispatch(setSuccessSnack(true));
        } else {
          // Agent not running - show install dialog
          setShowSocketInstallDialog(true);
        }
      } catch (error) {
        console.error('Socket print check failed:', error);
        // Show install dialog on connection failure
        setShowSocketInstallDialog(true);
      }
    } else {
      disconnectSocket();
      setSocketConnected(false);
      setDeviceForms({ ...deviceForms, useSocketPrint: false });
      getAllPrinterDevicesAPICall();
    }
  };

  // Handle successful Socket Print Agent installation
  const handleSocketInstallSuccess = (printers) => {
    setSocketConnected(true);
    setDeviceForms({ ...deviceForms, useSocketPrint: true, useBrowserPrint: false });
    setQzTrayConnected(false);
    dispatch(store_printers_list(printers || []));
    dispatch(setSnackMsg(`Socket Print Agent installed! ${(printers || []).length} printer(s) found.`));
    dispatch(setSuccessSnack(true));
  };

  // Handle Socket Print install dialog close (cancelled)
  const handleSocketInstallClose = () => {
    setShowSocketInstallDialog(false);
  };

  useEffect(()=>{
    const initializePrinters = async () => {
      let printSettingsString=localStorage.getItem('PrinterSettings')
      let printSettings=JSON.parse(printSettingsString)

      // Check if QZ credentials are configured
      setQzCredentialsConfigured(hasQzCredentials());

      // Priority: Socket Print > QZ Tray > Thermal utility
      if (printSettings?.useSocketPrint) {
        try {
          const available = await isSocketPrintAvailable();
          if (available) {
            setSocketConnected(true);
            const printers = await getSocketPrinters();
            dispatch(store_printers_list(printers || []));
          } else {
            getAllPrinterDevicesAPICall();
          }
        } catch {
          getAllPrinterDevicesAPICall();
        }
      } else if (printSettings?.useBrowserPrint) {
        const available = await isQzTrayAvailable();
        if (available) {
          setQzTrayConnected(true);
          const printers = await getQzPrinters();
          dispatch(store_printers_list(printers));
        } else {
          getAllPrinterDevicesAPICall();
        }
      } else {
        getAllPrinterDevicesAPICall();
      }

      setDeviceForms({...deviceForms,
                      receipt:printSettings?.receiptPrinter || null,
                      kot:printSettings?.kotPrinter || null,
                      receiptSize:printSettings?.receiptSize || null,
                      receiptImgMode:printSettings?.receiptImgMode|| null,
                      logoHeight:printSettings?.logoHeight || "",
                      kotSize:printSettings?.kotSize || null,
                      receiptAuto:printSettings?.receiptAuto || false,
                      enableBarcode:printSettings?.enableBarcode || false,
                      enableQrCode:printSettings?.enableQrCode || false,
                      kotAuto:printSettings?.kotAuto || false,
                      enableKotNativeName:printSettings?.enableKotNativeName || false,
                      enableKotPrint: printSettings?.enableKotPrint || false,
                      enableKotPrintAfterPayment: printSettings?.enableKotPrintAfterPayment || false,
                      enableNativeName:printSettings?.enableNativeName || false,
                      useBrowserPrint:printSettings?.useBrowserPrint || false,
                      useSocketPrint:printSettings?.useSocketPrint || false,
                      kotFilterType: printSettings?.kotFilterType || 'none',
                      kotFilterProducts: printSettings?.kotFilterProducts || [],
                      kotFilterCategories: printSettings?.kotFilterCategories || [],
                      kotRawMaterial: printSettings?.kotRawMaterial || false,
                      kotPrintNotes: printSettings?.kotPrintNotes || false,
                    });
      // Load additional printers
      setAdditionalReceiptPrinters(printSettings?.additionalReceiptPrinters || []);
      setAdditionalKotPrinters(printSettings?.additionalKotPrinters || []);
    };

    initializePrinters();

    // Fetch products list for KOT filter options
    axios.post("readymade/productListForDashBoard", {}, HEADERS)
      .then((res) => {
        if (res.status === 200) {
          dispatch(update_all_products_list({ allProductsList: res.data }));
        }
      })
      .catch((err) => console.error("Failed to load products for KOT filter:", err?.response?.status));

    // Fetch POS categories for KOT filter options
    axios.get("inventory/viewPosCategory", {}, HEADERS)
      .then((res) => {
        if (res.status === 200) {
          dispatch(get_all_posCategory({ posCategoryData: res.data }));
        }
      })
      .catch((err) => console.error("Failed to load POS categories for KOT filter:", err?.response?.status));
  },[])

  return (
    <div className="device-settings-container">
        <p className="breadcrumb">Device Settings</p>

        <div className="device-settings-body">

      <div className="device-settings-container-left device-settings-container-left1">

        <div className="device-settings-container-left-section">
          {
          devices.map((device,index) =>
            <div
              key={index} 
              // onClick={()=>clickDeviceSettingsPrinter(device)}
              className={`device-settings-container-left-list ${activeBtn===device?"focus":'disabled-list'}`}
            >
              <ul style={{width:"100%"}}>
                <li>
                  {device}

                 {device==="Printer" && <DownloadButton style={{marginLeft:"60px"}}/>}
                </li>
              </ul>
            </div>
          )  
        }
        </div>
      </div>
      <div className="device-settings-container-right">
        {activeBtn === "Printer" ? (
          <div>
            <div className="device-settings-container-right-section">
              <div className="device-settings-container-right-printer">
                <div className="device-settings-container-right-printer-top">
                  <p>Receipt</p>

                    <div className='pos-settings-checkbox-container'>
                    
                      <label htmlFor="enableBarcode">Barcode</label>
                      <input
                        type="checkbox"
                        id="enableBarcode"
                        checked={deviceForms.enableBarcode}
                        onChange={(e) => setDeviceForms({ ...deviceForms, enableBarcode: e.target.checked })}
                      />

                      <label htmlFor="enableQrCode">QR Code</label>
                      <input
                        type="checkbox"
                        id="enableQrCode"
                        checked={deviceForms.enableQrCode}
                        onChange={(e) => setDeviceForms({ ...deviceForms, enableQrCode: e.target.checked })}
                      />
                      <label htmlFor="enableNativeName">Native name</label>
                      <input
                        type="checkbox"
                        id="enableNativeName"
                        checked={deviceForms.enableNativeName}
                        onChange={(e) => setDeviceForms({ ...deviceForms, enableNativeName: e.target.checked })}
                      />
                    </div>
                  <div className="justify-center" style={{gap:"10px"}}> 
                    <p>Auto</p>
                    <input 
                    className="toggle-checkbox"
                    type="checkBox" 
                    checked={deviceForms.receiptAuto}
                    onChange={(e)=>setDeviceForms({...deviceForms,receiptAuto:e.target.checked})}
                    />
                  </div>
                </div>
                <div className="global-single-input auto-complete" style={{ width: "100%" }}>
                  <div className="justify-center" style={{justifyContent:"start",gap:"5px",flexWrap:"wrap"}}> 

                  {/* Always show printer dropdown */}
                  <Autocomplete 
                  options={printersList || []}
                  getOptionLabel={(option)=>option}
                  value={deviceForms?.receipt} onChange={devicesOnChange("receipt")}
                  renderInput={(params)=>(
                    <TextField {...params} placeholder={deviceForms.useBrowserPrint ? "Select printer (QZ Tray)" : "Select printer"}/>
                  )}
                  sx={{width: "75%",height:"29px"}}
                  />
                 <Autocomplete
                    options={printersSize}
                    getOptionLabel={(option) => option}
                    value={deviceForms?.receiptSize}
                    onChange={devicesOnChange("receiptSize")}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="size" />
                    )}
                    sx={{ width:"20%",height: "31px", paddingTop: "6px" }}
                  />
                  <Autocomplete 
                  options={imgModes}
                  getOptionLabel={(option)=>option}
                  value={deviceForms?.receiptImgMode} 
                  onChange={devicesOnChange("receiptImgMode")}
                  renderInput={(params)=>(
                    <TextField {...params} placeholder="Image Mode"/>
                  )}
                  sx={{paddingTop:"6px",width:"30%"}}
                  />
                  {/* <Autocomplete 
                  options={imgModes}
                  freeSolo
                  getOptionLabel={(option)=>option}
                  value={deviceForms?.receiptImgMode} 
                  onChange={devicesOnChange("receiptImgMode")}
                  renderInput={(params)=>(
                    <TextField {...params} placeholder="Logo Size"/>
                  )}
                  sx={{paddingTop:"6px",width:"30%"}}
                  /> */}
                    <input style={{width:"25%"}}
                    value={deviceForms?.logoHeight} 
                    onChange={devicesOnChange("logoHeight")}
                    type="text" placeholder="Logo Height"/>
                    <div className='pos-settings-checkbox-container'>
                      <label htmlFor="enableKotPrint">Kot print</label>
                      <input
                        type="checkbox"
                        id="enableKotPrint"
                        checked={deviceForms.enableKotPrint}
                        onChange={(e) => setDeviceForms({ ...deviceForms, enableKotPrint: e.target.checked })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Add Additional Receipt Printer Section */}
            <div className="device-settings-container-right-section" style={{ borderLeft: '3px solid #4caf50' }}>
              <div className="device-settings-container-right-printer">
                <div className="device-settings-container-right-printer-top" style={{ cursor: 'pointer' }} onClick={addReceiptPrinter}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <AddCircleOutlineIcon style={{ color: '#4caf50' }} />
                    <p style={{ margin: 0 }}>Add additional receipt printer</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Render Additional Receipt Printers */}
            {additionalReceiptPrinters.map((printer, index) => (
              <div key={`receipt-${index}`} className="device-settings-container-right-section" style={{ borderLeft: '3px solid #2196f3', marginLeft: '10px' }}>
                <div className="device-settings-container-right-printer">
                  <div className="device-settings-container-right-printer-top">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                      <TextField
                        size="small"
                        placeholder="Area name (e.g., Kitchen)"
                        value={printer.areaName}
                        onChange={(e) => updateReceiptPrinter(index, 'areaName', e.target.value)}
                        sx={{ width: '200px' }}
                        InputProps={{ style: { fontSize: '12px' } }}
                      />
                      <span style={{ color: '#2196f3', fontSize: '12px', fontWeight: 'bold' }}>
                        {printer.areaName ? `(${printer.areaName})` : ''}
                      </span>
                    </div>
                    <div className='pos-settings-checkbox-container'>
                      <label>Barcode</label>
                      <input type="checkbox" checked={printer.enableBarcode} onChange={(e) => updateReceiptPrinter(index, 'enableBarcode', e.target.checked)} />
                      <label>QR Code</label>
                      <input type="checkbox" checked={printer.enableQrCode} onChange={(e) => updateReceiptPrinter(index, 'enableQrCode', e.target.checked)} />
                      <label>Native name</label>
                      <input type="checkbox" checked={printer.enableNativeName} onChange={(e) => updateReceiptPrinter(index, 'enableNativeName', e.target.checked)} />
                    </div>
                    <div className="justify-center" style={{ gap: '10px' }}>
                      <p>Auto</p>
                      <input className="toggle-checkbox" type="checkbox" checked={printer.auto} onChange={(e) => updateReceiptPrinter(index, 'auto', e.target.checked)} />
                    </div>
                    <IconButton size="small" onClick={() => removeReceiptPrinter(index)} style={{ color: '#f44336' }}>
                      <DeleteOutlineIcon />
                    </IconButton>
                  </div>
                  <div className="global-single-input auto-complete" style={{ width: '100%' }}>
                    <div className="justify-center" style={{ justifyContent: 'start', gap: '5px', flexWrap: 'wrap' }}>
                      <Autocomplete
                        options={printersList || []}
                        getOptionLabel={(option) => option}
                        value={printer.printer}
                        onChange={(e, newValue) => updateReceiptPrinter(index, 'printer', newValue)}
                        renderInput={(params) => <TextField {...params} placeholder="Select printer" />}
                        sx={{ width: '75%', height: '29px' }}
                      />
                      <Autocomplete
                        options={printersSize}
                        getOptionLabel={(option) => option}
                        value={printer.size}
                        onChange={(e, newValue) => updateReceiptPrinter(index, 'size', newValue)}
                        renderInput={(params) => <TextField {...params} placeholder="size" />}
                        sx={{ width: '20%', height: '31px', paddingTop: '6px' }}
                      />
                      <Autocomplete
                        options={imgModes}
                        getOptionLabel={(option) => option}
                        value={printer.imgMode}
                        onChange={(e, newValue) => updateReceiptPrinter(index, 'imgMode', newValue)}
                        renderInput={(params) => <TextField {...params} placeholder="Image Mode" />}
                        sx={{ paddingTop: '6px', width: '30%' }}
                      />
                      <input
                        style={{ width: '25%' }}
                        value={printer.logoHeight}
                        onChange={(e) => updateReceiptPrinter(index, 'logoHeight', e.target.value.replace(/[^0-9]/g, ''))}
                        type="text"
                        placeholder="Logo Height"
                      />
                      <div className='pos-settings-checkbox-container'>
                        <label>Kot print</label>
                        <input type="checkbox" checked={printer.enableKotPrint} onChange={(e) => updateReceiptPrinter(index, 'enableKotPrint', e.target.checked)} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className="device-settings-container-right-section">
              <div className="device-settings-container-right-printer">
                <div className="device-settings-container-right-printer-top">
                  <p>KOT</p>

                  <div className='pos-settings-checkbox-container'>
                  <label htmlFor="enableKotNativeName">Native name</label>
                      <input
                        type="checkbox"
                        id="enableKotNativeName"
                        checked={deviceForms.enableKotNativeName}
                        onChange={(e) => setDeviceForms({ ...deviceForms, enableKotNativeName: e.target.checked })}
                      />
                  </div>
                  <div className="justify-center" style={{gap:"10px"}}> 
                    <p>Auto</p>
                    <input 
                    className="toggle-checkbox"
                    type="checkBox" 
                    checked={deviceForms.kotAuto}
                    onChange={(e)=>setDeviceForms({...deviceForms,kotAuto:e.target.checked})}
                    />
                  </div>
                </div>
                <div className="global-single-input auto-complete" style={{ width: "100%" }}>

                <div className="justify-center" style={{justifyContent:"start",gap:"5px"}}> 

                {/* Always show printer dropdown */}
                <Autocomplete 
                  options={printersList || []}
                  getOptionLabel={(option)=>option}
                  value={deviceForms?.kot} onChange={devicesOnChange("kot")}
                  renderInput={(params)=>(
                    <TextField {...params} placeholder={deviceForms.useBrowserPrint ? "Select printer (QZ Tray)" : "Select printer"}/>
                  )}
                  sx={{width: "90%"}}
                  />

                <Autocomplete
                  options={printersSize}
                  getOptionLabel={(option) => option}
                  value={deviceForms?.kotSize}
                  onChange={devicesOnChange("kotSize")}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="size" />
                  )}
                  sx={{ height: "29px", paddingTop: "6px" }}
                />
                </div>
                  </div>
              </div>
              <div className='pos-settings-checkbox-container' sx={{ paddingTop: "10px"}}>
                <label htmlFor="enableKotPrintAfterPayment">Kot print after payment</label>
                <input
                  type="checkbox"
                  id="enableKotPrintAfterPayment"
                  checked={deviceForms.enableKotPrintAfterPayment}
                  onChange={(e) => setDeviceForms({ ...deviceForms, enableKotPrintAfterPayment: e.target.checked })}
                />
              </div>

              {/* KOT Filter Options */}
              <div style={{ padding: '10px 0', borderTop: '1px dashed #ccc', marginTop: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                  <label style={{ fontSize: '12px', fontWeight: 'bold', minWidth: '80px' }}>KOT Filter:</label>
                  <Autocomplete
                    options={kotFilterTypes}
                    getOptionLabel={(option) => option === 'none' ? 'None' : option === 'product' ? 'Product Wise' : 'Category Wise'}
                    value={deviceForms.kotFilterType || 'none'}
                    onChange={(e, newValue) => setDeviceForms({ ...deviceForms, kotFilterType: newValue || 'none', kotFilterProducts: [], kotFilterCategories: [] })}
                    renderInput={(params) => <TextField {...params} placeholder="Filter type" />}
                    sx={{ width: '200px' }}
                    size="small"
                    disableClearable
                  />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <input type="checkbox" checked={deviceForms.kotRawMaterial || false} onChange={(e) => setDeviceForms({ ...deviceForms, kotRawMaterial: e.target.checked })} />
                    <label style={{ fontSize: '12px' }}>raw material from Recipe</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <input type="checkbox" checked={deviceForms.kotPrintNotes || false} onChange={(e) => setDeviceForms({ ...deviceForms, kotPrintNotes: e.target.checked })} />
                    <label style={{ fontSize: '12px' }}>Print Notes</label>
                  </div>
                </div>
                {deviceForms.kotFilterType === 'product' && (
                  <Autocomplete
                    multiple
                    options={allProductsList || []}
                    getOptionLabel={(option) => option?.name || option?.productName || ''}
                    value={deviceForms.kotFilterProducts || []}
                    onChange={(e, newValue) => setDeviceForms({ ...deviceForms, kotFilterProducts: newValue })}
                    isOptionEqualToValue={(option, value) => option?._id === value?._id}
                    renderInput={(params) => <TextField {...params} placeholder="Select products" />}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip size="small" label={option?.name || option?.productName} {...getTagProps({ index })} key={option?._id} />
                      ))
                    }
                    size="small"
                    sx={{ marginTop: '5px' }}
                  />
                )}
                {deviceForms.kotFilterType === 'category' && (
                  <Autocomplete
                    multiple
                    options={posCategoryList || []}
                    getOptionLabel={(option) => option?.name || ''}
                    value={deviceForms.kotFilterCategories || []}
                    onChange={(e, newValue) => setDeviceForms({ ...deviceForms, kotFilterCategories: newValue })}
                    isOptionEqualToValue={(option, value) => option?._id === value?._id}
                    renderInput={(params) => <TextField {...params} placeholder="Select categories" />}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip size="small" label={option?.name} {...getTagProps({ index })} key={option?._id} />
                      ))
                    }
                    size="small"
                    sx={{ marginTop: '5px' }}
                  />
                )}
              </div>
            </div>

            {/* Add Additional KOT Printer Section */}
            <div className="device-settings-container-right-section" style={{ borderLeft: '3px solid #4caf50' }}>
              <div className="device-settings-container-right-printer">
                <div className="device-settings-container-right-printer-top" style={{ cursor: 'pointer' }} onClick={addKotPrinter}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <AddCircleOutlineIcon style={{ color: '#4caf50' }} />
                    <p style={{ margin: 0 }}>Additional KOT Printer</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Render Additional KOT Printers */}
            {additionalKotPrinters.map((printer, index) => (
              <div key={`kot-${index}`} className="device-settings-container-right-section" style={{ borderLeft: '3px solid #ff9800', marginLeft: '10px' }}>
                <div className="device-settings-container-right-printer">
                  <div className="device-settings-container-right-printer-top">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                      <TextField
                        size="small"
                        placeholder="Area name (e.g., Shawrma KOT)"
                        value={printer.areaName}
                        onChange={(e) => updateKotPrinter(index, 'areaName', e.target.value)}
                        sx={{ width: '200px' }}
                        InputProps={{ style: { fontSize: '12px' } }}
                      />
                      <span style={{ color: '#ff9800', fontSize: '12px', fontWeight: 'bold' }}>
                        {printer.areaName ? `(${printer.areaName})` : ''}
                      </span>
                    </div>
                    <div className='pos-settings-checkbox-container'>
                      <label>Native name</label>
                      <input type="checkbox" checked={printer.enableNativeName} onChange={(e) => updateKotPrinter(index, 'enableNativeName', e.target.checked)} />
                    </div>
                    <div className="justify-center" style={{ gap: '10px' }}>
                      <p>Auto</p>
                      <input className="toggle-checkbox" type="checkbox" checked={printer.auto} onChange={(e) => updateKotPrinter(index, 'auto', e.target.checked)} />
                    </div>
                    <IconButton size="small" onClick={() => removeKotPrinter(index)} style={{ color: '#f44336' }}>
                      <DeleteOutlineIcon />
                    </IconButton>
                  </div>
                  <div className="global-single-input auto-complete" style={{ width: '100%' }}>
                    <div className="justify-center" style={{ justifyContent: 'start', gap: '5px' }}>
                      <Autocomplete
                        options={printersList || []}
                        getOptionLabel={(option) => option}
                        value={printer.printer}
                        onChange={(e, newValue) => updateKotPrinter(index, 'printer', newValue)}
                        renderInput={(params) => <TextField {...params} placeholder="Select printer" />}
                        sx={{ width: '90%' }}
                      />
                      <Autocomplete
                        options={printersSize}
                        getOptionLabel={(option) => option}
                        value={printer.size}
                        onChange={(e, newValue) => updateKotPrinter(index, 'size', newValue)}
                        renderInput={(params) => <TextField {...params} placeholder="size" />}
                        sx={{ height: '29px', paddingTop: '6px' }}
                      />
                    </div>
                  </div>
                  <div className='pos-settings-checkbox-container' style={{ paddingTop: '10px' }}>
                    <label>Kot print after payment</label>
                    <input type="checkbox" checked={printer.enableKotPrintAfterPayment} onChange={(e) => updateKotPrinter(index, 'enableKotPrintAfterPayment', e.target.checked)} />
                  </div>

                  {/* KOT Filter Options for additional printer */}
                  <div style={{ padding: '10px 0', borderTop: '1px dashed #ccc', marginTop: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                      <label style={{ fontSize: '12px', fontWeight: 'bold', minWidth: '80px' }}>KOT Filter:</label>
                      <Autocomplete
                        options={kotFilterTypes}
                        getOptionLabel={(option) => option === 'none' ? 'None' : option === 'product' ? 'Product Wise' : 'Category Wise'}
                        value={printer.kotFilterType || 'none'}
                        onChange={(e, newValue) => {
                          const updated = [...additionalKotPrinters];
                          updated[index] = { ...updated[index], kotFilterType: newValue || 'none', kotFilterProducts: [], kotFilterCategories: [] };
                          setAdditionalKotPrinters(updated);
                        }}
                        renderInput={(params) => <TextField {...params} placeholder="Filter type" />}
                        sx={{ width: '200px' }}
                        size="small"
                        disableClearable
                      />
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <input type="checkbox" checked={printer.kotRawMaterial || false} onChange={(e) => updateKotPrinter(index, 'kotRawMaterial', e.target.checked)} />
                        <label style={{ fontSize: '12px' }}>raw material</label>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <input type="checkbox" checked={printer.kotPrintNotes || false} onChange={(e) => updateKotPrinter(index, 'kotPrintNotes', e.target.checked)} />
                        <label style={{ fontSize: '12px' }}>Print Notes</label>
                      </div>
                    </div>
                    {printer.kotFilterType === 'product' && (
                      <Autocomplete
                        multiple
                        options={allProductsList || []}
                        getOptionLabel={(option) => option?.name || option?.productName || ''}
                        value={printer.kotFilterProducts || []}
                        onChange={(e, newValue) => updateKotPrinter(index, 'kotFilterProducts', newValue)}
                        isOptionEqualToValue={(option, value) => option?._id === value?._id}
                        renderInput={(params) => <TextField {...params} placeholder="Select products" />}
                        renderTags={(value, getTagProps) =>
                          value.map((option, idx) => (
                            <Chip size="small" label={option?.name || option?.productName} {...getTagProps({ index: idx })} key={option?._id} />
                          ))
                        }
                        size="small"
                        sx={{ marginTop: '5px' }}
                      />
                    )}
                    {printer.kotFilterType === 'category' && (
                      <Autocomplete
                        multiple
                        options={posCategoryList || []}
                        getOptionLabel={(option) => option?.name || ''}
                        value={printer.kotFilterCategories || []}
                        onChange={(e, newValue) => updateKotPrinter(index, 'kotFilterCategories', newValue)}
                        isOptionEqualToValue={(option, value) => option?._id === value?._id}
                        renderInput={(params) => <TextField {...params} placeholder="Select categories" />}
                        renderTags={(value, getTagProps) =>
                          value.map((option, idx) => (
                            <Chip size="small" label={option?.name} {...getTagProps({ index: idx })} key={option?._id} />
                          ))
                        }
                        size="small"
                        sx={{ marginTop: '5px' }}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}

            <div className="device-settings-container-right-section">
              <div className="device-settings-container-right-printer">
                <div className="device-settings-container-right-printer-top">
                  <p>BARCODE</p>
                </div>
                <div className="global-single-input auto-complete" style={{ width: "100%" }}>
                <Autocomplete 
                  options={printersList || []}
                  getOptionLabel={(option)=>option}
                  value={deviceForms?.barCode} onChange={devicesOnChange("barcode")}
                  renderInput={(params)=>(
                    <TextField {...params}/>
                  )}
                  />
                </div>
              </div>
            </div>

            {/* QZ Tray - Additional Auto Printing Mode */}
            <div className="device-settings-container-right-section">
              <div className="device-settings-container-right-printer">
                <div className="device-settings-container-right-printer-top" style={{ justifyContent: "space-between", width: "100%" }}>
                  <p>ADDITIONAL AUTO PRINTING</p>
                  <div className='pos-settings-checkbox-container'>
                    <label htmlFor="useBrowserPrint" style={{ fontSize: "12px", color: "#666" }}>
                      Enable QZ Tray (Silent Print)
                    </label>
                    <input
                      type="checkbox"
                      id="useBrowserPrint"
                      checked={deviceForms.useBrowserPrint}
                      disabled={deviceForms.useSocketPrint}
                      onChange={(e) => handleQzTrayToggle(e.target.checked)}
                    />
                  </div>
                </div>
                
                {/* Connection Status */}
                {deviceForms.useBrowserPrint && (
                  <div style={{ 
                    padding: "8px 12px", 
                    backgroundColor: qzTrayConnected ? "#e8f5e9" : "#fff3e0", 
                    borderRadius: "4px", 
                    marginBottom: "10px",
                    border: `1px solid ${qzTrayConnected ? "#a5d6a7" : "#ffcc80"}`,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <span style={{ fontSize: "16px" }}>{qzTrayConnected ? "✅" : "⚠️"}</span>
                    <span style={{ fontSize: "12px", color: qzTrayConnected ? "#2e7d32" : "#e65100" }}>
                      {qzTrayConnected ? "QZ Tray Connected - Silent printing enabled" : "QZ Tray not connected - Click checkbox to setup"}
                    </span>
                  </div>
                )}

                <div style={{ padding: "10px", fontSize: "12px", color: "#888", backgroundColor: "#f5f5f5", borderRadius: "4px" }}>
                  <p style={{ margin: "0 0 5px 0" }}>
                    <strong>ℹ️ QZ Tray - Silent Printing:</strong>
                  </p>
                  <ul style={{ margin: 0, paddingLeft: "20px" }}>
                    <li>Enables <strong>silent printing</strong> without any dialog</li>
                    <li>Works with any Windows printer</li>
                    <li>One-time installation of QZ Tray app required</li>
                    <li>Printers will appear in dropdown above when connected</li>
                  </ul>
                  
                  {/* Certificate Configuration for truly silent printing */}
                  <div style={{ marginTop: "10px", padding: "8px", backgroundColor: qzCredentialsConfigured ? "#e8f5e9" : "#fff8e1", borderRadius: "4px", border: `1px solid ${qzCredentialsConfigured ? "#a5d6a7" : "#ffe082"}` }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div>
                        <strong>{qzCredentialsConfigured ? "🔐 Certificate Configured" : "⚠️ Certificate Not Configured"}</strong>
                        <p style={{ margin: "4px 0 0 0", fontSize: "11px" }}>
                          {qzCredentialsConfigured 
                            ? "Silent printing enabled - no popup will appear" 
                            : "Configure certificate to remove Allow/Block popup"}
                        </p>
                      </div>
                      <button 
                        onClick={() => setShowQzCredentialsDialog(true)}
                        style={{ 
                          padding: "6px 12px", 
                          fontSize: "11px", 
                          backgroundColor: qzCredentialsConfigured ? "#4caf50" : "#ff9800", 
                          color: "white", 
                          border: "none", 
                          borderRadius: "4px", 
                          cursor: "pointer" 
                        }}
                      >
                        {qzCredentialsConfigured ? "Reconfigure" : "Configure Certificate"}
                      </button>
                    </div>
                  </div>

                  <p style={{ margin: "10px 0 5px 0" }}>
                    <strong>🔄 Alternative:</strong>
                  </p>
                  <ul style={{ margin: 0, paddingLeft: "20px" }}>
                    <li>Keep this OFF to use existing thermal print utility (localhost:5000)</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Socket Print - Node/Socket.IO Silent Print Mode */}
            <div className="device-settings-container-right-section">
              <div className="device-settings-container-right-printer">
                <div className="device-settings-container-right-printer-top" style={{ justifyContent: "space-between", width: "100%" }}>
                  <p>SOCKET PRINT MODE</p>
                  <div className='pos-settings-checkbox-container'>
                    <label htmlFor="useSocketPrint" style={{ fontSize: "12px", color: "#666" }}>
                      Enable Socket Print (Node/Socket.IO)
                    </label>
                    <input
                      type="checkbox"
                      id="useSocketPrint"
                      checked={deviceForms.useSocketPrint}
                      disabled={deviceForms.useBrowserPrint}
                      onChange={(e) => handleSocketPrintToggle(e.target.checked)}
                    />
                  </div>
                </div>
                
                {/* Connection Status */}
                {deviceForms.useSocketPrint && (
                  <div style={{ 
                    padding: "8px 12px", 
                    backgroundColor: socketConnected ? "#e8f5e9" : "#fff3e0", 
                    borderRadius: "4px", 
                    marginBottom: "10px",
                    border: `1px solid ${socketConnected ? "#a5d6a7" : "#ffcc80"}`,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <span style={{ fontSize: "16px" }}>{socketConnected ? "✅" : "⚠️"}</span>
                    <span style={{ fontSize: "12px", color: socketConnected ? "#2e7d32" : "#e65100" }}>
                      {socketConnected 
                        ? "Socket connected to print agent - Silent printing enabled" 
                        : "Socket not connected - Ensure ClientPrintAgent is running"}
                    </span>
                    {!socketConnected && (
                      <button
                        onClick={() => handleSocketPrintToggle(true)}
                        style={{ marginLeft: "auto", padding: "4px 10px", fontSize: "11px", backgroundColor: "#ff9800", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" }}
                      >
                        Retry
                      </button>
                    )}
                  </div>
                )}

                <div style={{ padding: "10px", fontSize: "12px", color: "#888", backgroundColor: "#f5f5f5", borderRadius: "4px" }}>
                  <p style={{ margin: "0 0 5px 0" }}>
                    <strong>🔌 Socket Print - Silent Printing via Socket.IO:</strong>
                  </p>
                  <ul style={{ margin: 0, paddingLeft: "20px" }}>
                    <li>Auto silent print - no dialog, no popup</li>
                    <li>Printers appear in dropdown above when connected</li>
                    <li>Auto-starts as Windows service on boot</li>
                    <li>No QZ Tray or certificate setup needed</li>
                  </ul>
                  {!socketConnected && (
                    <div style={{ marginTop: "8px" }}>
                      <button
                        onClick={() => setShowSocketInstallDialog(true)}
                        style={{ padding: "6px 14px", fontSize: "12px", backgroundColor: "#1976d2", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" }}
                      >
                        📥 Install ClientPrintAgent
                      </button>
                      <span style={{ marginLeft: "8px", fontSize: "11px", color: "#999" }}>One-click setup</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ): undefined}

        {/* Receipt Template Selection Section */}
        <div style={{ marginTop: "20px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px", border: "1px solid #dee2e6" }}>
          <div style={{ marginBottom: "12px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
              <strong style={{ fontSize: "14px" }}>🧾 Receipt Template (Offline)</strong>
              <Select
                value={currentFont}
                onChange={(e) => {
                  const font = e.target.value;
                  setCurrentFont(font);
                  localStorage.setItem('posReceiptFont', font);
                  dispatch(setSnackMsg(`Receipt font set to ${font}`));
                  dispatch(setSuccessSnack(true));
                }}
                size="small"
                style={{ minWidth: "160px", fontSize: "13px", fontFamily: currentFont }}
              >
                {fontOptions.map((f) => (
                  <MenuItem key={f.value} value={f.value} style={{ fontFamily: f.value }}>{f.label}</MenuItem>
                ))}
              </Select>
            </div>
            <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#666" }}>
              Select template for this device. Click image to preview.
            </p>
          </div>
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            {templateOptions.map((template) => (
              <div
                key={template.id}
                style={{
                  border: currentTemplate === template.id.toString() ? "3px solid #1976d2" : "2px solid #ddd",
                  borderRadius: "8px",
                  padding: "8px",
                  cursor: "pointer",
                  backgroundColor: currentTemplate === template.id.toString() ? "#e3f2fd" : "white",
                  textAlign: "center",
                  width: "120px"
                }}
              >
                <div
                  style={{ width: "100px", height: "140px", overflow: "hidden", cursor: "zoom-in", border: "1px solid #eee", borderRadius: "4px", backgroundColor: "#fff" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setPreviewTemplateId(template.id);
                    setTemplatePreviewOpen(true);
                  }}
                >
                  <div style={{ transform: "scale(0.48)", transformOrigin: "top left", width: "208px", pointerEvents: "none" }}>
                    <ReceiptTemplatePreview templateId={template.id} font={currentFont} logo={companyLogo} />
                  </div>
                </div>
                <p 
                  style={{ 
                    margin: "4px 0 0 0", 
                    fontSize: "10px", 
                    fontWeight: currentTemplate === template.id.toString() ? "bold" : "normal",
                    color: currentTemplate === template.id.toString() ? "#1976d2" : "#333"
                  }}
                  onClick={() => handleTemplateSelect(template.id, template.label)}
                >
                  {template.label}
                </p>
                <span style={{ fontSize: "8px", color: "#888" }}>{template.desc}</span>
                <button
                  onClick={() => handleTemplateSelect(template.id, template.label)}
                  style={{
                    marginTop: "6px",
                    padding: "4px 12px",
                    fontSize: "10px",
                    backgroundColor: currentTemplate === template.id.toString() ? "#1976d2" : "#e0e0e0",
                    color: currentTemplate === template.id.toString() ? "white" : "#333",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer"
                  }}
                >
                  {currentTemplate === template.id.toString() ? "✓ Selected" : "Select"}
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Template Preview Dialog */}
        <Dialog open={templatePreviewOpen} onClose={() => setTemplatePreviewOpen(false)} maxWidth="sm">
          <DialogTitle style={{ textAlign: "center", paddingBottom: 0 }}>
            Template Preview
            <IconButton
              onClick={() => setTemplatePreviewOpen(false)}
              style={{ position: "absolute", top: 8, right: 8 }}
            >
              <CancelIcon color="error" />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ display: "flex", justifyContent: "center", padding: "16px" }}>
            {previewTemplateId && (
              <div style={{ width: "300px", border: "1px solid #ddd", borderRadius: "4px", padding: "8px", backgroundColor: "#fff" }}>
                <ReceiptTemplatePreview templateId={previewTemplateId} font={currentFont} logo={companyLogo} />
              </div>
            )}
          </DialogContent>
        </Dialog>

        <div className="device-settings-right-container-button">
          <button className="btn btn-primary" onClick={deviceSubmitClick}>Submit</button>
        </div>
      </div>
      </div>

      {/* QZ Tray Installation Dialog */}
      <QzTrayInstallDialog
        open={showQzInstallDialog}
        onClose={handleQzInstallClose}
        onSuccess={handleQzInstallSuccess}
      />

      {/* Socket Print Agent Installation Dialog */}
      <SocketPrintInstallDialog
        open={showSocketInstallDialog}
        onClose={handleSocketInstallClose}
        onSuccess={handleSocketInstallSuccess}
      />

      {/* QZ Tray Credentials Dialog for Silent Printing */}
      <QzTrayCredentialsDialog
        open={showQzCredentialsDialog}
        onClose={() => setShowQzCredentialsDialog(false)}
        onSuccess={handleCredentialsSuccess}
      />
    </div>
  );
};
